import { LocalStorage } from "utils/LocalStorage";
import { useAppSelector } from "./useAppSelector";
import { userSelector } from "reduxStore/auth/selectors";

export const useAuthUser = () => {
  const token = LocalStorage.getToken();
  const user = useAppSelector(userSelector);
  const role = user?.role;

  return {
    token,
    user,
    role,
  };
};
